import React from 'react';
import { useSignupStep } from '@/app/(auth)/signup/components/signupStep/SignupStepContext';
import { RedirectBuilder } from '@/utils/redirectUrls';
import { useIsFixUp } from '@/app/(auth)/signup/components/signupStep/useIsFixUp';

const linkClasses = 'tw:text-primary tw:underline tw:underline-offset-2';

export const StepNavigationLinks = (props: { showSignIn?: boolean }) => {
  const { redirectConfig, stepId } = useSignupStep();
  const redirectBuilder = new RedirectBuilder(redirectConfig?.baseUrl, redirectConfig?.nexudusRedirectUrl);

  const isFixup = useIsFixUp();

  // The sign-in prompt only makes sense while the account is still hypothetical: past the first
  // step one is already being created, and the callers that already offer a Sign in button
  // (the email-already-in-use screens) opt out explicitly
  const showSignIn = props.showSignIn ?? stepId === 'personal';

  if (isFixup || !showSignIn) {
    return null;
  }

  return (
    <div className="tw:flex tw:flex-col tw:gap-1 tw:text-sm tw:font-normal tw:leading-7 tw:text-foreground">
      <p className="tw:m-0">
        Already have an account?{' '}
        <a href={redirectBuilder.buildStartLoginUrl()} className={linkClasses}>
          Sign in here
        </a>
      </p>
    </div>
  );
};
